export const ZERO_HYPHEN = '—';
